$ = jQuery; // in case of no-conflict jquery

marninsaylor.site = new marninsaylor.MarninSaylorSite({ // config data
  //
});

// on page loaded
$(function() {
  marninsaylor.site.init();
});